module.exports = __webpack_public_path__ + "static/spotifybadge-ea8e8eb125e4903a951e8e562f30f95e.svg";